const labels = {
  filterBy: 'FILTER BY',
  inspectedBy: 'Inspected By',
  inspectedOn: 'Inspected On',
};

export { labels };
